export default __webpack_public_path__ + "static/media/platform_advantages_icon3.a73834d5.png";